import React from "react";

export default function Marquee({ items = [], className = "" }) {
    const doubled = [...items, ...items];
    return (
        <div
            className={`relative overflow-hidden edge-fade-x ${className}`}
            data-testid="marquee"
        >
            <div className="flex gap-12 animate-marquee whitespace-nowrap py-2 w-[200%]">
                {doubled.map((it, i) => (
                    <span
                        key={i}
                        className="font-display text-zinc-500 hover:text-white transition-colors text-2xl md:text-3xl tracking-tight"
                    >
                        {it}
                    </span>
                ))}
            </div>
        </div>
    );
}
